var $ = require('jquery');

var self = {};

self.initialise = function() {
  var $goToLinks = $('.goto-enquiry');

  var pageRequestManager = Sys.WebForms.PageRequestManager.getInstance();
  pageRequestManager.add_endRequest(scrollToForm);

  $(document).ready(function() {
    var $form = $('.enquiry-form');

    if ($form.length === 0) {
      $goToLinks.hide();
    } else {
      var $header = $('header');

      $goToLinks.click(function(e) {
        e.preventDefault();
        $('html, body').animate(
          {
            scrollTop: $form.offset().top - ($header.height() + 20),
          },
          1000
        );
      });
    }
  });

  function scrollToForm() {
    if ($('.contact-confirmation').length > 0) {
      var navOffset = 0;
      if ($('.page-navigation').length > 0) {
        navOffset = $('.page-navigation').outerHeight();
      }

      $('html,body').animate({
        scrollTop: $('.contact-confirmation').offset().top - navOffset,
      });
    }
  }
};
module.exports = self;



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/modules/enquiryForm.js